import { isNil } from 'lodash';
import React, { useCallback, useContext } from 'react';
import { CardChannelContext } from '@shared/components/blocks/contexts/channel';
import { CardBlockScrollContext } from '@shared/components/blocks/contexts/scroll';
import { MBCardChatInput } from '@shared/scenes/chat/input/containers/input/card';

interface Props {
  cardId: string;
}

export function MBChatThreadInputBlock({ cardId }: Props) {
  const channel = useContext(CardChannelContext);
  const channelSlug = channel?.slug;
  const scrollView = useContext(CardBlockScrollContext);
  if (!scrollView) {
    console.warn(
      'Rendering card thread input block without CardBlockScrollContext being set. Did you forget to wrap these card blocks in CardBlockScrollProvider?',
    );
  }

  const scrollToBottom = useCallback(() => {
    // Wait until the next run so that the newly sent message has been rendered
    setTimeout(() => scrollView?.current?.scrollToEnd(), 0);
  }, [scrollView]);

  if (isNil(channelSlug)) {
    return null;
  }

  return (
    <MBCardChatInput
      cardId={cardId}
      channelSlug={channelSlug}
      onSend={scrollToBottom}
      onFocus={scrollToBottom}
    />
  );
}
